module.exports = __webpack_public_path__ + "static/media/goog.eecafaf5.svg";